import { useEffect, useState } from 'react';

import { clsx } from 'clsx';
import { RefreshCw } from 'lucide-react';

import { Button } from '../../components/ui/Button';

interface ProductImageFlipCardProps {
    image?: string | null;
    secondaryImage?: string | null;
    imageAlt: string;
}

export default function ProductImageFlipCard({
    image,
    secondaryImage,
    imageAlt,
}: ProductImageFlipCardProps) {
    const [showingSecondaryImage, setShowingSecondaryImage] = useState(false);
    const hasSecondaryImage = Boolean(secondaryImage);

    useEffect(() => {
        setShowingSecondaryImage(false);
    }, [image, secondaryImage, imageAlt]);

    return (
        <div className="mx-auto flex w-full max-w-[240px] flex-col gap-3 lg:ml-0">
            <div className="w-full [perspective:1200px]">
                <div
                    className={clsx(
                        'grid w-full rounded-lg transition-all duration-400 ease-in-out [transform-style:preserve-3d] motion-reduce:transition-none',
                        showingSecondaryImage
                            ? 'scale-[1.02] shadow-2xl'
                            : 'scale-100 shadow-lg',
                    )}
                    style={{
                        transform: showingSecondaryImage
                            ? 'rotateY(180deg)'
                            : 'rotateY(0deg)',
                    }}
                    data-testid="product-image"
                >
                    <img
                        src={image || '/placeholder.svg'}
                        alt={imageAlt}
                        className="col-start-1 row-start-1 block w-full rounded-lg object-cover [backface-visibility:hidden]"
                    />
                    {hasSecondaryImage && secondaryImage && (
                        <img
                            src={secondaryImage}
                            alt={`${imageAlt}, зворотна сторона`}
                            className="col-start-1 row-start-1 block w-full rounded-lg object-cover [backface-visibility:hidden]"
                            style={{
                                transform: 'rotateY(180deg)',
                            }}
                        />
                    )}
                </div>
            </div>

            {hasSecondaryImage && (
                <Button
                    variant="outline"
                    size="sm"
                    className="w-full gap-2"
                    data-testid="product-image-flip-button"
                    onClick={() =>
                        setShowingSecondaryImage(
                            (currentValue) => !currentValue,
                        )
                    }
                >
                    <span
                        className={clsx(
                            'inline-flex transition-transform duration-400 ease-in-out motion-reduce:transition-none',
                        )}
                        style={{
                            transform: showingSecondaryImage
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                        }}
                    >
                        <RefreshCw className="h-4 w-4" />
                    </span>
                    Перевернути
                </Button>
            )}
        </div>
    );
}
